import React, { useState } from 'react'
import './FlatButton.css'

type LedColor = 'amber' | 'emerald' | 'green' | 'lime' | 'cyan'

interface FlatButtonProps {
  labelTop: string // e.g., "ON"
  ledColor: LedColor // 'amber' or 'emerald'
  onClick?: () => void
  disabled?: boolean
  isActive?: boolean // Optional controlled state
}

const FlatButton: React.FC<FlatButtonProps> = ({
  labelTop,
  ledColor = 'amber',
  onClick,
  disabled = false,
  isActive: controlledIsActive,
}) => {
  const [internalIsActive, setInternalIsActive] = useState(false)

  // Use controlled state if provided, otherwise use internal state
  const isActive =
    controlledIsActive !== undefined ? controlledIsActive : internalIsActive

  const handleClick = () => {
    if (disabled) return

    // Toggle internal state if not controlled
    if (controlledIsActive === undefined) {
      setInternalIsActive(!internalIsActive)
    }

    // Call the onClick handler if provided
    onClick?.()
  }

  return (
    <div className="control-unit" onClick={handleClick}>
      <span className="control-label">{labelTop}</span>

      {/* LED Indicator */}
      <div className={`led ${ledColor} ${isActive ? 'active' : 'inactive'}`} />

      {/* Physical Button */}
      <button
        className={`hw-btn-housing ${isActive ? 'active' : ''}`}
        disabled={disabled}
      >
        <div className="hw-btn-inner">
          <div className="hw-btn-face">
            <div className="hw-btn-highlight" />
          </div>
          <div className="hw-btn-lip" />
        </div>
      </button>
    </div>
  )
}

export default FlatButton
